import * as React from 'react';
const SvgWarning = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={120}
    height={120}
    fill="none"
    viewBox="0 0 120 120"
    {...props}
  >
    <circle cx={60} cy={60} r={60} fill="#E6F1FF" />
    <circle cx={32.596} cy={24} r={2.25} fill="#5EA8FF" />
    <g filter="url(#a)" opacity={0.36}>
      <path
        fill="#003DE4"
        d="M55.757 21.118a6 6 0 0 1 8.486 0l34.64 34.64a6 6 0 0 1 0 8.485l-34.64 34.64a6 6 0 0 1-8.486 0l-34.64-34.64a6 6 0 0 1 0-8.486z"
      />
    </g>
    <path
      fill="#fff"
      d="M55.757 21.118a6 6 0 0 1 8.486 0l34.64 34.64a6 6 0 0 1 0 8.485l-34.64 34.64a6 6 0 0 1-8.486 0l-34.64-34.64a6 6 0 0 1 0-8.486z"
    />
    <rect width={9} height={31.5} x={55.5} y={37.5} fill="#003DE4" rx={4.5} />
    <path fill="#003DE4" d="M60 73.5a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9" />
    <path
      fill="#126CFB"
      d="M29.735 92.022c.332-1.234 2.16-1.234 2.492 0l.174.646c.12.448.492.794.963.896l.363.078a1.224 1.224 0 0 1 0 2.408l-.363.079c-.47.102-.842.447-.963.895l-.174.647c-.333 1.234-2.16 1.234-2.492 0l-.175-.647a1.26 1.26 0 0 0-.963-.895l-.362-.079a1.224 1.224 0 0 1 0-2.408l.362-.078c.471-.102.843-.448.963-.896z"
    />
    <path
      fill="#CCE7FF"
      d="M92.003 88.087c.266-.988 1.728-.988 1.994 0l.14.517c.096.358.393.635.77.716l.29.063a.98.98 0 0 1 0 1.927l-.29.062a1.01 1.01 0 0 0-.77.716l-.14.518c-.266.987-1.728.987-1.994 0l-.14-.518a1.01 1.01 0 0 0-.77-.716l-.29-.062a.98.98 0 0 1 0-1.927l.29-.063c.377-.081.674-.358.77-.716z"
    />
    <circle cx={38.596} cy={105} r={2.25} fill="#CCE7FF" />
    <path
      fill="#CCE7FF"
      fillRule="evenodd"
      d="M22.75 35.058a2.5 2.5 0 0 0 2.5-2.5 2.5 2.5 0 1 1-2.5 2.5m0 0a2.5 2.5 0 0 1 2.5-2.5 2.5 2.5 0 1 0-2.5 2.5"
      clipRule="evenodd"
    />
    <path
      fill="#5EA8FF"
      d="M96.254 34.676c.333-1.235 2.16-1.235 2.492 0l.175.646c.12.448.492.794.962.895l.363.079a1.224 1.224 0 0 1 0 2.408l-.362.079c-.471.101-.843.447-.963.895l-.175.647c-.332 1.233-2.16 1.233-2.492 0l-.174-.647a1.26 1.26 0 0 0-.963-.895l-.363-.079a1.224 1.224 0 0 1 0-2.408l.363-.079c.47-.101.842-.447.963-.895z"
    />
    <circle cx={105.75} cy={43.039} r={1.5} fill="#126CFB" />
    <defs>
      <filter
        id="a"
        width={111.279}
        height={111.279}
        x={4.36}
        y={4.36}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur
          result="effect1_foregroundBlur_414_3266"
          stdDeviation={7.5}
        />
      </filter>
    </defs>
  </svg>
);
export default SvgWarning;
